<template>
  <div class="flex flex-col relative rounded-2xl pb-12 md:pb-24">
    <img
      class="rounded-2xl md:h-64 md:object-cover"
      :src="src"
      :alt="alt"
      :width="width"
      :height="height"
    >

    <button
      class="transition-all duration-300 ease-in-out absolute bottom-0 flex flex-col justify-center gap-4 w-full text-left rounded-2xl border p-4 bg-white shadow-sm overflow-hidden"
      :class="isOpen ? 'max-h-full mb-2' : 'max-h-20 h-20 mb-0'"
      @click="isOpen = !isOpen"
    >
      <div class="flex items-center justify-between w-full">
        <span class="text-xl">{{ title }}</span>
        <svg-icon
          name="chevron-down"
          class="text-black w-3 h-3 shrink-0"
          :class="{ 'rotate-180': !isOpen }"
        />
      </div>
      <p v-show="isOpen">
        {{ body }}
      </p>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
const isOpen = ref(false)
export interface Props {
  title: string
  body: string
  src: string
  alt: string
  width: number | string
  height: number | string
}
defineProps<Props>()
</script>
